var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['userButton', {collapse: _vm.collapse}]},[_c('div',{staticClass:"userButton-avatar"}),(!_vm.collapse)?_c('span',{staticClass:"userButton-user"},[_vm._v(_vm._s(_vm.user.fullName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }